import { createMuiTheme } from "@material-ui/core";
import { color } from "./Color";
import { hexToRGB } from "./utlity";

import EuclidR from "../Assets/Fonts/EuclidCircularB-Regular-WebS.woff2";
import EuclidM from "../Assets/Fonts/EuclidCircularB-Medium-WebS.woff2";

const euclidRegular = {
  fontFamily: "Euclid",
  fontStyle: "normal",
  fontDisplay: "swap",
  fontWeight: 400,
  src: `
    local('Euclid'),
    local('Euclid-Regular'),
    url(${EuclidR}) format('woff2')
  `,
};
const euclidMedium = {
  fontFamily: "Euclid",
  fontStyle: "normal",
  fontDisplay: "swap",
  fontWeight: 500,
  src: `
    local('Euclid'),
    local('Euclid-Medium'),
    url(${EuclidM}) format('woff2')
  `,
};

export const theme = createMuiTheme({
  palette: {
    type: "light",
    common: {
      black: color.black,
    },
    primary: {
      main: color.primary,
    },
    btnDisabled: hexToRGB(color.primary, 0.2),
    grey: {
      100: color.gray100,
      300: color.gray300,
    },
    error: {
      light: color.error100,
      main: color.error,
    },
    divider: color.gray300,
    background: {
      default: color.white,
    },
  },
  typography: {
    fontSize: 17,
    // fontFamily: ["Roboto", "sans-serif"].join(",")
    fontFamily: ["Euclid", "sans-serif"].join(","), // @Todo replace font family with new one
    fontWeightBold: 500,
    h1: {
      fontSize: "35px",
      fontWeight: 300,
      marginBottom: "44px",
      lineHeight: 1.4,
      color: "color.black",
      letterSpacing: "-0.03em",
      "@media (max-width:767px)": {
        fontSize: 20,
        letterSpacing: "-0.015em",
      },
    },
    h2: {
      fontSize: "30px",
      marginBottom: "40px",
      fontWeight: 300,
      lineHeight: 1.4,
      letterSpacing: "-0.03em",
      "@media (max-width:767px)": {
        fontSize: 20,
        letterSpacing: "-0.015em",
      },
    },
    h3: {
      fontSize: "26px",
      marginBottom: "20px",
      fontWeight: 500,
      lineHeight: 1.4,
      letterSpacing: "-0.015em",
      "@media (max-width:767px)": {
        fontSize: 19,
        fontWeight: 500,
        letterSpacing: "-0.01em",
      },
    },
    h4: {
      fontSize: "20px",
      marginBottom: "20px",
      fontWeight: 500,
    },
    h5: {
      fontSize: "18px",
      marginBottom: "20px",
      fontWeight: 500,
    },
    h6: {
      fontSize: "14px",
      marginBottom: "20px",
      fontWeight: 500,
    },
    button: {
      fontWeight: 500,
      fontSize: 19,
      textTransform: "inherit",
      boxShadow: "none",
      minWidth: "150px",
      letterSpacing: "-0.015em",
    },
    body1: {
      fontSize: 17,
    },
  },
  shape: {
    borderRadius: 4,
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "@font-face": [euclidRegular, euclidMedium],
      },
    },
    MuiDialogTitle: {
      root: {
        "& h2": {
          fontSize: "18px",
        },
      },
    },
    MuiFormHelperText: {
      root: {
        margin: "8px 0px 0",
        fontSize: 10,
      },
    },
  },
});
